import { observable, runInAction } from 'mobx'

const GlobalState = observable({
  cname: '',
  website: '',
  desciption: '',
  products: [],
  dataset: [ ],
  poiskdataset: [ ],
  portraits: [],
  attachname: [],
  datasetPrew:[],
  segmentations: [ ],
  loadsegmentations: 1,
  segmentationsCategory: [],
  portraitsheduledeploycred:[],
  portraitsheduledeployname:"",
  portraitsheduledeployname2:"",
  portraitsheduledeployevery:"",
  portraitsheduledeploydata:"",
  sheduleEvery:"",
  sheduleHour:"01",
  sheduleMinute:"00",
  portraitsheduledeploystarttime:"",
  singleCompain:[],

  activedatasetSegment: {
    id:"",
    idWorkspace:"",
    nameSegment: "",
    nameDataset: "",
    Columns: "", 
    Rows: "", 
    file_key: "",
    file_name: "",
    key_column: "",
    segmentations: [],
    source: "",
    status: "",
    upload_time: "",
    user_id: ""
  },
  activeDatasetClause:[],
  inputNameClause: '',
  elsevalClause: '',
  clauseType:"",
  clauseCre:"",
  compaings:[],
  microsegments:[
    {
      title: "Revenue",
      options: [{
        name: "Low",
        subname: "Number of Objects",
        value: "7 000",
        cheked: "false"
      },
      {
        name: "Mid Low",
        subname: "Number of Objects",
        value: "8 500",
        cheked: "false"
      },
      {
        name: "Mid",
        subname: "Number of Objects",
        value: "2 400",
        cheked: "false"
      },
      {
        name: "Mid High",
        subname: "Number of Objects",
        value: "12 857",
        cheked: "true"
      }]
    },
    {
      title: "Trades",
      options: [{
        name: "<=10 ",
        subname: "Number of Objects",
        value: "2 000",
        cheked: "false"
      },
      {
        name: ">10; <=20 ",
        subname: "Number of Objects",
        value: "3 500",
        cheked: "false"
      },
      {
        name: ">20; <=60 ",
        subname: "Number of Objects",
        value: "1 300",
        cheked: "false"
      },
      {
        name: ">60",
        subname: "Number of Objects",
        value: "6 057",
        cheked: "false"
      }]
    },
    // {
    //   title: "Lifecycle",
    //   options: [{
    //     name: "Onetime",
    //     subname: "Number of Objects",
    //     value: "1 100",
    //     cheked: "false"
    //   },
    //   {
    //     name: "Beginner",
    //     subname: "Number of Objects",
    //     value: "1 700",
    //     cheked: "false"
    //   },
    //   {
    //     name: "Mid",
    //     subname: "Number of Objects",
    //     value: "1 000",
    //     cheked: "false"
    //   },
    //   {
    //     name: "Regular",
    //     subname: "Number of Objects",
    //     value: "1 000",
    //     cheked: "false"
    //   }]
    // }
  ],
  messages:[
    {id:0, check: false, successful: false}
  ],
  models:[],
  activemodel:[],
  activeThresholdLower: 0.5,
  activeThresholdUpper: 0.5,
  activemodeldatasetprew:[],
  activemodeldatasetprewbigquery:[],
  activemodeldatasetprewbigquerypredict:[],
  prewdatasetbigquery:[],
  prewdatasetbigquerypredict:[],
  deploycsv: 0,
  segmentdeploymass1:[],
  segmentdeploymass2:[],
  gmessage: false,
  numbersubmenu: 1,
  categorySegment:"",
  countdatasetshow:0,
  ispopupinfoShow: false,
  ispopupproductShow: false,
  ispopupproductShow2: false,
  ispopupaddworkspaceShow: false,
  ispopupadddatasetShow: false,
  ispopupaddAttachmentShow: false,
  ispopupaddAttachmentShowbigdata: 0,
  ispopupaddAttachmentShowAnalitics: false,
  ispopupaddAttachmentShowAnaliticsbigdata: 0,
  ispopupdeleteProductShow: false,
  ispopupdeleteDatasetShow: false,
  ispopuprefreshDatasetShow: false,
  ispopuprefreshDatasetShowcsv: false,
  ispopuprefreshDatasetnum: 0,
  ispopupdeletedatasetid: "",
  ispopupdeleteatasetname: "",
  ispopupDeploymentShow: false,
  ispopupdeleteCompanyShow: false,
  ispopupdeleteMessageShow: false,
  ispopupdeleteWorkspaceShow: false,
  ispopupdeleteColumnShow: false,
  ispopupdeleteClauseShow: false,
  ispopupdeleteSheduleShow: false,
  ispopupcloseSheduleShow: false,
  ispopupdeleteClauseId:"",
  ispopupdeleteClauseVId:"",
  ispopupdeleteTableShow: false,
  ispopupcloseselectattributeShow: false,
  ispopupcloseEditDeployShow: false,
  ispopupMicrosegmentShow: false,
  ispopupaddSegmentationShow: false,
  ispopupaddNewMessage: false,
  curentIdProduct: 'z',
  datasetflag: 0,
  portraitflag: 0,
  modelflag: 0,
  activemodelflag: 0,
  inputDataset:"",
  outputDataset:"",
  inputDatasetname:"",
  outputDatasetname:"",
  credentialbigquery:[],
  tablebigquery:"",
  comgaingdeleteid:"",
  comgaingdeletename:"",
  ispopupdeleteModelShow: false,
  ispopupdeletemodelid:"",
  ispopupsavenewmessage:false,
  ispopupaddSegmentShow: false,
  allpagesmodels:0,
  numpagesmodels:1,
  numpagesdatasets:1,
  numpagesdatasetsportraits:1,
  datasetinmodel:[],
  datasetstottal:0,
  modelstottal:0,
  iddeleteCompany:"",
  iddeleteMessage:"",
  mickrosegments:[],
  idchangecompany:"",
  newmessageemptycompany:[],
  mikrosegmentations:[],
  dataworksektion:"",
  segmentationitems:[{title: "user_id",titletext:"Unique values:&nbsp;&nbsp;&nbsp;&nbsp;<span>60 000</span>&nbsp;&nbsp;<span>99%</span>", list:["28779510", "85749826","28779510", "85749826","28779510", "85749826","28779510", "85749826","28779510", "85749826","28779510", "85749826","28779510", "85749826"]}],
  segmentationpage:"2",
  segmentationpagecenter1:"1",
  segmentationpagecenter2:"1",
  segmentsheduleid:"",
  activeSegmentThresholdId: 0,
  idDeleteColumn: 0,
  activeportraits:[],
  VId2:"",
  emailuser: localStorage.getItem("emailuser")||"",
  ifblock:[{then:"", list:[{title: "if", activColumn: "", typeColumn:"", operator:[{operator:"", value:"", select:false}]}]}],
  ifblockNull:[{then:"", list:[{title: "if", activColumn: "", typeColumn:"", operator:[{operator:"", value:"", select:false}]}]}],
  strategyId:""
})

export default GlobalState


export const changeEmailUser = (a) => {
  runInAction(() => {

      GlobalState.emailuser = a;
      localStorage.setItem("emailuser",a);
  })
}
export const changePortraitsheduledeploycred = (a) => {
  runInAction(() => {

      GlobalState.portraitsheduledeploycred = a;
      localStorage.setItem("emailuser",a);
  })
}

export const changeAttachName = (a) => {
  runInAction(() => {

      GlobalState.attachname = a;
      console.log(GlobalState.attachname + "trin")
  })
}

export const changeActiveSegmentThreshold = (segmentId) => {
  runInAction(() => {
    GlobalState.activeSegmentThresholdId = segmentId;
  });
};

export const changeSingleCompain = (a) => {
  runInAction(() => {
      GlobalState.singleCompain = a;
      
  })
}

export const changeStrategyId = (a) => {
  runInAction(() => {
      GlobalState.strategyId = a;
      
  })
}


export const changePortraitsheduledeployname = (a) => {
  runInAction(() => {

      GlobalState.portraitsheduledeployname = a;
      localStorage.setItem("emailuser",a);
  })
}
export const changePortraitsheduledeployname2 = (a) => {
  runInAction(() => {

      GlobalState.portraitsheduledeployname2 = a;
      localStorage.setItem("emailuser",a);
  })
}

export const changePortraitsheduledeploynameAll = (a, b, v, id, d) => {
  runInAction(() => {

      GlobalState.portraitsheduledeployname = a;
      GlobalState.portraitsheduledeployevery = b;
      GlobalState.portraitsheduledeploystarttime = v;
      GlobalState.segmentsheduleid = id;
      GlobalState.portraitsheduledeploydata = d;


  })
}

export const setEvery = (a) => {
  runInAction(() => {
      GlobalState.sheduleEvery = a;
  })
}
export const setHour = (a) => {
  runInAction(() => {
      GlobalState.sheduleHour = a;
  })
}
export const setMinut = (a) => {
  runInAction(() => {
      GlobalState.sheduleMinute = a;
  })
}







export const setifblock = (a) => {
  runInAction(() => {

      GlobalState.ifblock = a;
  })
}

export const setifblockNull = (a) => {
  runInAction(() => {

      GlobalState.ifblockNull = a;
  })
}


export const changemikrosegmentations = (a) => {
  runInAction(() => {

      GlobalState.segmentationitems = a;
  })
}

export const changeActivePortraits = (a) => {
  runInAction(() => {

      GlobalState.activeportraits = a;
  })
}

export const changeIDdeletecolumn = (a) => {
  runInAction(() => {

      GlobalState.idDeleteColumn = a;
  })
}
export const changesegmentationpage = (a) => {
  runInAction(() => {
      GlobalState.segmentationpage = a;
  })
}
export const changesegmentationpagecenter1 = (a) => {
  runInAction(() => {
      GlobalState.segmentationpagecenter1 = a;
  })
}
export const changesegmentsheduleid = (a) => {
  runInAction(() => {
      GlobalState.segmentsheduleid = a;
  })
}

export const changesegmentationpagecenter2 = (a) => {
  runInAction(() => {
      GlobalState.segmentationpagecenter2 = a;
  })
}
export const changesegmentationitems = (a) => {
  runInAction(() => {
      GlobalState.segmentationitems = a;
  })
}
export const changepopuprefreshDatasetnum = (a) => {
  runInAction(() => {
      GlobalState.ispopuprefreshDatasetnum = a;
  })
}
export const changedataworksektion = (a) => {
  runInAction(() => {
      GlobalState.dataworksektion = a;
  })
}

export const changedatasettottal = (a) => {
  runInAction(() => {
      GlobalState.datasetstottal = a;
  })
}
export const changemodalstottal = (a) => {
  runInAction(() => {
      GlobalState.modelstottal = a;
  })
}
export const minusnumpagesmodels = () => {
  runInAction(() => {
    if(GlobalState.numpagesmodels>1)
    {
      GlobalState.numpagesmodels = GlobalState.numpagesmodels*1-1;
    }
  })
}
export const plusnumpagesmodels = () => {
  runInAction(() => {
    if(GlobalState.numpagesmodels<GlobalState.allpagesmodels)
    {
      GlobalState.numpagesmodels = GlobalState.numpagesmodels*1+1;
    }
  })
}

export const minusnumpagesmodelsportraits = () => {
  runInAction(() => {
    if(GlobalState.numpagesdatasetsportraits>1)
    {
      GlobalState.numpagesdatasetsportraits = GlobalState.numpagesdatasetsportraits*1-1;
    }
  })
}
export const plusnumpagesmodelsportraits = (limit) => {
  runInAction(() => {
    if(GlobalState.numpagesdatasetsportraits<(GlobalState.activeportraits?.total/limit))
    {
      GlobalState.numpagesdatasetsportraits = GlobalState.numpagesdatasetsportraits*1+1;
    }
  })
}

export const minusnumpagesdatasets = () => {
  runInAction(() => {
    if(GlobalState.numpagesdatasets>1)
    {
      GlobalState.numpagesdatasets = GlobalState.numpagesdatasets*1-1;
    }
  })
}
export const plusnumpagesdatasets = (countlist) => {
  runInAction(() => {
    if(GlobalState.numpagesdatasets<Math.ceil(GlobalState.datasetstottal/countlist))
    {
      GlobalState.numpagesdatasets = GlobalState.numpagesdatasets*1+1;
    }
  })
}
export const nullnumpagesdatasets = (countlist) => {
  runInAction(() => {
   
      GlobalState.numpagesdatasets = 1;
    
  })
}

export const addmickrosegments = (m) => {
  runInAction(() => {
    GlobalState.mickrosegments = m;
  })
}
export const addnewmessageemptycompany = (m) => {
  runInAction(() => {
    GlobalState.newmessageemptycompany = m;
  })
}


export const changeallpagesmodels = (count) => {
  runInAction(() => {
    GlobalState.allpagesmodels = count
  })
}
export const changeinfocname = (cname) => {
  runInAction(() => {
    GlobalState.cname = cname
  })
}
export const changeLoadSegmentation = (name) => {
  runInAction(() => {
    GlobalState.loadsegmentations = name
  })
}
export const deletecompaingproduct = (id, name) => {
  runInAction(() => {
    GlobalState.comgaingdeleteid = id
    GlobalState.comgaingdeletename = name
  })
}
export const changeinfowebsite = (website) => {
  runInAction(() => {
    GlobalState.website = website
  })
}
export const changecredentialbigquery = (website) => {
  runInAction(() => {
    GlobalState.credentialbigquery = website
  })
}
export const changetablebigquery = (website) => {
  runInAction(() => {
    GlobalState.tablebigquery = website
  })
}
export const changeinfodescriptions = (desciption) => {
  runInAction(() => {
    GlobalState.desciption = desciption
  })
}

export const addsegmentdeploymass1 = (mass) => {
  runInAction(() => {
    GlobalState.segmentdeploymass1 = mass
  })
}

export const addsegmentdeploymass2 = (mass) => {
  runInAction(() => {
    GlobalState.segmentdeploymass2 = mass
  })
}

export const changeInputDataset = (dataset) => {
  runInAction(() => {
    GlobalState.inputDataset = dataset
  })
}

export const changeOutputDataset = (dataset) => {
  runInAction(() => {
    GlobalState.outputDataset = dataset
  })
}

export const changeInputDatasetName = (dataset) => {
  runInAction(() => {
    GlobalState.inputDatasetname = dataset
  })
}

export const changeOutputDatasetName = (dataset) => {
  runInAction(() => {
    GlobalState.outputDatasetname = dataset
  })
}

export const clearinfoproduct = () => {
  runInAction(() => {
    GlobalState.products = []
  })
}
export const addinfoproduct = (product) => {
  runInAction(() => {
    GlobalState.products = [...GlobalState.products, product]
  })
}
export const adddataset = (dataset) => {
  runInAction(() => {
    GlobalState.dataset = [...GlobalState.dataset, dataset]
  })
}
export const addPoiskdataset = (dataset) => {
  runInAction(() => {
    GlobalState.poiskdataset = [...GlobalState.poiskdataset, dataset]
  })
}
export const clearPoiskdataset = () => {
  runInAction(() => {
    GlobalState.poiskdataset = [];
  })
}

export const setShow = () => {
  runInAction(() => {
    GlobalState.countdatasetshow = GlobalState.countdatasetshow + 1;
  })
}
export const setShownum = (num) => {
  runInAction(() => {
    GlobalState.countdatasetshow = num;
  })
}

export const changePoiskdataset = (dataset) => {
  runInAction(() => {
    GlobalState.poiskdataset = dataset
  })
}
export const addportraits = (portraits) => {
  runInAction(() => {
    GlobalState.portraits = [...GlobalState.portraits, portraits]
  })
}
export const cleardataset = () => {
  runInAction(() => {
    GlobalState.dataset = []
  })
}
export const datasetworkspace = (dataset) => {
  runInAction(() => {
    GlobalState.datasetPrew = dataset
  })
}
export const addsegmentations = (segmentations) => {
  runInAction(() => {
    GlobalState.segmentations= [...GlobalState.segmentations, segmentations]
  })
}
export const addsegmentationsCategory = (segment) => {
  runInAction(() => {
    GlobalState.segmentationsCategory= [...GlobalState.segmentationsCategory, segment]
  })
}
export const addModels = (model) => {
  runInAction(() => {
    GlobalState.models= [...GlobalState.models, model]
  })
}
export const allModels = (model) => {
  runInAction(() => {
    GlobalState.models=model
  })
}
export const changesegmentationsCategory = (segment) => {
  runInAction(() => {
    GlobalState.segmentationsCategory = segment
  })
}
export const addactivedataset = (dataset) => {
  runInAction(() => {
    GlobalState.activedatasetSegment = dataset
  })
}
export const changeinfoproductstype = (id, name) => {
  runInAction(() => {
    if(name!='')
    {
      GlobalState.products[id].type = name
    }
    
  })
}
export const changeinfoproductsname = (id, name) => {
  runInAction(() => {
    if(name!='')
    {
      GlobalState.products[id].name = name
    }
  })
}
export const changeinfoproductsdescription = (id, name) => {
  runInAction(() => {
    GlobalState.products[id].desciption = name
  })
}
export const curentIdProduct = (name) => {
  runInAction(() => {
    GlobalState.curentIdProduct = name
  })
}

export const changeActiveModel = (n) => {
  runInAction(() => {
    GlobalState.activemodel = n
  })
}

export const changeActiveModelLastTrain = (lastTrainData) => {
  runInAction(() => {
    if (!GlobalState.activemodel) return;

    GlobalState.activemodel.lastTrain.metadata = lastTrainData;
  });
};

export const changeActiveThreshold = (lower, upper) => {
  runInAction(() => {
    GlobalState.activeThresholdLower = lower;
    GlobalState.activeThresholdUpper = upper;
  });
};

export const changeActiveModeldatasetPrew = (n) => {
  runInAction(() => {
    GlobalState.activemodeldatasetprew = n
  })
}
export const changedatasetinModel = (n) => {
  runInAction(() => {
    GlobalState.datasetinmodel = n
  })
}

export const changeActiveModeldatasetPrewbigquery = (n) => {
  runInAction(() => {
    GlobalState.activemodeldatasetprewbigquery = n
  })
}
export const changeActiveModeldatasetPrewbigquerypredict = (n) => {
  runInAction(() => {
    GlobalState.activemodeldatasetprewbigquerypredict = n
  })
}
export const changePrewdatasetbigquery = (n) => {
  runInAction(() => {
    GlobalState.prewdatasetbigquery = n
  })
}
export const changePrewdatasetbigquerypredict = (n) => {
  runInAction(() => {
    GlobalState.prewdatasetbigquerypredict = n
  })
}

export const changepopupinfo = () => {
  runInAction(() => {
    GlobalState.ispopupinfoShow = !GlobalState.ispopupinfoShow
  })
}

export const changepopupaddSegment = () => {
  runInAction(() => {
    GlobalState.ispopupaddSegmentShow = !GlobalState.ispopupaddSegmentShow
  })
}

export const changepopupsavenewmessage = () => {
  runInAction(() => {
    GlobalState.ispopupsavenewmessage = !GlobalState.ispopupsavenewmessage
  })
}
export const addpopupproduct = () => {
  runInAction(() => {
    GlobalState.ispopupproductShow = !GlobalState.ispopupproductShow
  })
}
export const changepopupproduct = (a) => {
  runInAction(() => {
    GlobalState.curentIdProduct = a;
    GlobalState.ispopupproductShow2 = !GlobalState.ispopupproductShow2
  })
}
export const changepopupNewMessage = (m) => {
  runInAction(() => {
    GlobalState.ispopupaddNewMessage = !GlobalState.ispopupaddNewMessage
    GlobalState.idchangecompany = m
  })
}

export const deletepopupproduct = (a) => {
  runInAction(() => {
    GlobalState.products.splice(a, 1);
  })
}
export const deletepopupdataset = (a) => {
  runInAction(() => {
    GlobalState.dataset.splice(a, 1);
  })
}

export const changepopupworkspace = () => {
  runInAction(() => {
    GlobalState.ispopupaddworkspaceShow = !GlobalState.ispopupaddworkspaceShow;
  })
}

export const changepopupSegmentation = () => {
  runInAction(() => {
    GlobalState.ispopupaddSegmentationShow = !GlobalState.ispopupaddSegmentationShow;
  })
}

export const changepopupdataset = () => {
  runInAction(() => {
    GlobalState.ispopupadddatasetShow = !GlobalState.ispopupadddatasetShow;
  })
}

export const changepopupdeleteProduct = () => {
  runInAction(() => {
    GlobalState.ispopupdeleteProductShow = !GlobalState.ispopupdeleteProductShow;
  })
}

export const changepopupdeleteDataset = (n ,id) => {
  runInAction(() => {
    GlobalState.ispopupdeleteDatasetShow = !GlobalState.ispopupdeleteDatasetShow;
    GlobalState.ispopupdeletedatasetid = n;
    GlobalState.ispopupdeleteatasetname = id;
  })
}
export const changepopupdeleteDatasetFlag = (n ,id) => {
  runInAction(() => {
    GlobalState.ispopupdeleteDatasetShow = !GlobalState.ispopupdeleteDatasetShow;
    GlobalState.ispopupdeletedatasetid = n;
    GlobalState.ispopupdeleteatasetname = id;
  })
}
export const changepopuprefreshDataset = (n ,id) => {
  runInAction(() => {
    GlobalState.ispopuprefreshDatasetShow = !GlobalState.ispopuprefreshDatasetShow;
    GlobalState.ispopupdeletedatasetid = n;
    GlobalState.ispopupdeleteatasetname = id;
  })
}
export const changepopuprefreshDatasetcsv = (n ,id) => {
  runInAction(() => {
    GlobalState.ispopuprefreshDatasetShowcsv = !GlobalState.ispopuprefreshDatasetShowcsv;
    GlobalState.ispopupdeletedatasetid = n;
    GlobalState.ispopupdeleteatasetname = id;
  })
}

export const changepopupdeleteModel = (n) => {
  runInAction(() => {
    GlobalState.ispopupdeleteModelShow = !GlobalState.ispopupdeleteModelShow;
    GlobalState.ispopupdeletemodelid = n;
  })
}

export const changepopupDeployment = () => {
  runInAction(() => {
    GlobalState.ispopupDeploymentShow = !GlobalState.ispopupDeploymentShow;
  })
}

export const changepopupdeleteCompany = (n) => {
  runInAction(() => {
    GlobalState.ispopupdeleteCompanyShow = !GlobalState.ispopupdeleteCompanyShow;
    GlobalState.iddeleteCompany = n;
  })
}
export const changepopupdeleteMessage = (n, b) => {
  runInAction(() => {
    GlobalState.ispopupdeleteMessageShow = !GlobalState.ispopupdeleteMessageShow;
    GlobalState.iddeleteMessage = n;
    GlobalState.idchangecompany = b;
  })
}
export const changepopupdeleteWorkspace = () => {
  runInAction(() => {
    GlobalState.ispopupdeleteWorkspaceShow = !GlobalState.ispopupdeleteWorkspaceShow;
  })
}

export const changepopupdeleteColumn = () => {
  runInAction(() => {
    GlobalState.ispopupdeleteColumnShow = !GlobalState.ispopupdeleteColumnShow;
  })
}
export const changepopupdeleteShedule = () => {
  runInAction(() => {
    GlobalState.ispopupdeleteSheduleShow = !GlobalState.ispopupdeleteSheduleShow;
  })
}

export const changepopupcloseShedule = () => {
  runInAction(() => {
    GlobalState.ispopupcloseSheduleShow = !GlobalState.ispopupcloseSheduleShow;
  })
}

export const changepopupdeleteClause = (id, activeDataset, im, el, vid, type, cr, f) => {
  runInAction(() => {
    //console.log()
    //GlobalState.ispopupdeleteClauseShow = !GlobalState.ispopupdeleteClauseShow;
    GlobalState.ispopupdeleteClauseId = id;
    GlobalState.ispopupdeleteClauseVId = vid;
    GlobalState.activeDatasetClause = activeDataset;
    GlobalState.inputNameClause = im;
    GlobalState.elsevalClause = el;
    GlobalState.clauseType = type;
    GlobalState.clauseCre = cr;
    GlobalState.VId2 = f;
  })
}

export const changepopupdeleteTable = () => {
  runInAction(() => {
    GlobalState.ispopupdeleteTableShow = !GlobalState.ispopupdeleteTableShow;
  })
}

export const changepopupCloseSelectAttribute = () => {
  runInAction(() => {
    GlobalState.ispopupcloseselectattributeShow = !GlobalState.ispopupcloseselectattributeShow;
  })
}

export const changepopupCloseEditDeploy = () => {
  runInAction(() => {
    GlobalState.ispopupcloseEditDeployShow = !GlobalState.ispopupcloseEditDeployShow;
  })
}



export const changepopupMicrosegment = () => {
  runInAction(() => {
    GlobalState.ispopupMicrosegmentShow = !GlobalState.ispopupMicrosegmentShow;
  })
}

export const changepopupaddAttachment = (a) => {
  runInAction(() => {
    GlobalState.ispopupaddAttachmentShow = !GlobalState.ispopupaddAttachmentShow;
    GlobalState.ispopupaddAttachmentShowbigdata = a;
  })
}
export const changepopupaddAttachmentbig = (a) => {
  runInAction(() => {
    GlobalState.ispopupaddAttachmentShowbigdata = a;
  })
}

export const changepopupaddAttachmentAnalitics = (a) => {
  runInAction(() => {
    GlobalState.ispopupaddAttachmentShowAnalitics = !GlobalState.ispopupaddAttachmentShowAnalitics;
    GlobalState.ispopupaddAttachmentShowAnaliticsbigdata = a;
  })
}

export const changedatasetflag = (flag) => {
  runInAction(() => {
    GlobalState.datasetflag = flag
  })
}

export const changeportraitflag = (flag) => {
  runInAction(() => {
    GlobalState.portraitflag = flag
  })
}

export const changemodelflag = (flag) => {
  runInAction(() => {
    GlobalState.modelflag = flag
  })
}
export const changeactivemodelflag = (flag) => {
  runInAction(() => {
    GlobalState.activemodelmodelflag = flag
  })
}
export const changeChannelCompany = (segment) => {
  runInAction(() => {
    GlobalState.compaings = segment
  })
}
export const addChannelCompany = (compaings) => {
  runInAction(() => {
    GlobalState.compaings =  compaings
  })
}
export const addmessage = (message) => {
  runInAction(() => {
    GlobalState.messages= [...GlobalState.messages, message]
  })
}
export const changemessages = (n) => {
  runInAction(() => {
    GlobalState.messages = n
    
    var rez = GlobalState.messages
    rez.map((i,z)=>
      i['check'] = "true"
    )
    GlobalState.messages = rez
    })
}
export const changemessagesone = (n) => {
  runInAction(() => {
    GlobalState.messages = n
    })
}
export const changemessagetext = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    console.log(text + "123456");
    rez.map((i,z)=>
      i.id.includes(id)?i.generated_message=text:<></>
    )
    changemessageT(rez)
  })
}
export const changemessageT = (text) => {
  runInAction(() => {
    GlobalState.messages = text
  })
}
export const changeMesName = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    rez.map((i,z)=>
      i.id.includes(id)?i.user_parameters.campaign_name=text:<></>
    )
    GlobalState.messages = rez
  })
}

export const changeCondition = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    rez.map((i,z)=>
      i.id.includes(id)?i.user_parameters.react=text:<></>
    )
    GlobalState.messages = rez
  })
}

export const ChangeMessageType = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    rez.map((i,z)=>
      i.id.includes(id)?i.user_parameters.message_type=text:<></>
    )
    GlobalState.messages = rez
  })
}
export const changeTool = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    rez.map((i,z)=>
      i.id.includes(id)?i.user_parameters.tool=text:<></>
    )
    GlobalState.messages = rez
  })
}
export const ChangeWritingStyle = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    rez.map((i,z)=>
      i.id.includes(id)?i.user_parameters.writing_style=text:<></>
    )
    GlobalState.messages = rez
  })
}

export const ChangeCopywritingFormula = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    rez.map((i,z)=>
      i.id.includes(id)?i.user_parameters.copywriting_formula=text:<></>
    )
    GlobalState.messages = rez
  })
}

export const changeGoal = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    rez.map((i,z)=>
      i.id.includes(id)?i.user_parameters.campaign_goal=text:<></>
    )
    GlobalState.messages = rez
  })
}

export const changeSignature = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    rez.map((i,z)=>
      i.id.includes(id)?i.user_parameters.signature=text:<></>
    )
    GlobalState.messages = rez
  })
}

export const ChangeCommunicationFormat = (id, text) => {
  runInAction(() => {
    var rez = GlobalState.messages;
    rez.map((i,z)=>
      i.id.includes(id)?i.user_parameters.communication_format=text:<></>
    )
    GlobalState.messages = rez
  })
}







export const gmessage = () => {
  runInAction(() => {
    GlobalState.gmessage = true
  })
}
export const catSegment = (n) => {
  runInAction(() => {
    GlobalState.categorySegment = n
  })
}
export const changenumsubmenu = (num) => {
  runInAction(() => {
    GlobalState.numbersubmenu = num
  })
}